/* unplugin-vue-components disabled */import { render } from "./ReferralsPage.vue?vue&type=template&id=632ead51&scoped=true"
import script from "./ReferralsPage.vue?vue&type=script&lang=js"
export * from "./ReferralsPage.vue?vue&type=script&lang=js"

import "./ReferralsPage.vue?vue&type=style&index=0&id=632ead51&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632ead51"]])

export default __exports__